import React from "react";
import { Outlet } from "react-router-dom";
import { SidebarProvider, useSidebar } from "../context/SidebarContext";
import { Sidebar } from "../components/Sidebar";
import styles from "./Layout.module.css";
import Header from "../components/Header";

const Layout: React.FC = () => {
  const { isOpen } = useSidebar();

  const sidebarWidthOpen = '270px';
  const sidebarWidthClosed = '88px';

  return (
    <div className={styles.layoutContainer}>
      <div
        className={styles.sidebar}
        style={{ width: isOpen ? sidebarWidthOpen : sidebarWidthClosed }}
      >
        <Sidebar />
      </div>
      <div className={styles.mainWrapper}>
        <Header />
        <main className={styles.content}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default function RootLayout() {
  return (
    <SidebarProvider>
      <Layout />
    </SidebarProvider>
  );
}